import type { Language } from 'app/lib/language';

const countries = [
  { name: { en: 'Afghanistan', fr: 'Afghanistan', es: 'Afganistán' }, code: 'AF' },
  { name: { en: 'Aland Islands', fr: 'Åland', es: 'Islas Åland' }, code: 'AX' },
  { name: { en: 'Albania', fr: 'Albanie', es: 'Albania' }, code: 'AL' },
  { name: { en: 'Algeria', fr: 'Algérie', es: 'Argelia' }, code: 'DZ' },
  { name: { en: 'American Samoa', fr: 'Samoa américaines', es: 'Samoa Americana' }, code: 'AS' },
  { name: { en: 'Andorra', fr: 'Andorre', es: 'Andorra' }, code: 'AD' },
  { name: { en: 'Angola', fr: 'Angola', es: 'Angola' }, code: 'AO' },
  { name: { en: 'Anguilla', fr: 'Anguilla', es: 'Anguila' }, code: 'AI' },
  { name: { en: 'Antarctica', fr: 'Antarctique', es: 'Antártida' }, code: 'AQ' },
  { name: { en: 'Antigua And Barbuda', fr: 'Antigua-et-Barbuda', es: 'Antigua y Barbuda' }, code: 'AG' },
  { name: { en: 'Argentina', fr: 'Argentine', es: 'Argentina' }, code: 'AR' },
  { name: { en: 'Armenia', fr: 'Arménie', es: 'Armenia' }, code: 'AM' },
  { name: { en: 'Aruba', fr: 'Aruba', es: 'Aruba' }, code: 'AW' },
  { name: { en: 'Australia', fr: 'Australie', es: 'Australia' }, code: 'AU' },
  { name: { en: 'Austria', fr: 'Autriche', es: 'Austria' }, code: 'AT' },
  { name: { en: 'Azerbaijan', fr: 'Azerbaïdjan', es: 'Azerbaiyán' }, code: 'AZ' },
  { name: { en: 'Bahrain', fr: 'Bahreïn', es: 'Baréin' }, code: 'BH' },
  { name: { en: 'Bangladesh', fr: 'Bangladesh', es: 'Bangladés' }, code: 'BD' },
  { name: { en: 'Barbados', fr: 'Barbade', es: 'Barbados' }, code: 'BB' },
  { name: { en: 'Belarus', fr: 'Biélorussie', es: 'Bielorrusia' }, code: 'BY' },
  { name: { en: 'Belgium', fr: 'Belgique', es: 'Bélgica' }, code: 'BE' },
  { name: { en: 'Belize', fr: 'Belize', es: 'Belice' }, code: 'BZ' },
  { name: { en: 'Benin', fr: 'Bénin', es: 'Benín' }, code: 'BJ' },
  { name: { en: 'Bermuda', fr: 'Bermudes', es: 'Bermudas' }, code: 'BM' },
  { name: { en: 'Bhutan', fr: 'Bhoutan', es: 'Bután' }, code: 'BT' },
  { name: { en: 'Bolivia', fr: 'Bolivie', es: 'Bolivia' }, code: 'BO' },
  {
    name: {
      en: 'Bonaire, Sint Eustatius and Saba',
      fr: 'Bonaire, Saint-Eustache et Saba',
      es: 'Bonaire, San Eustaquio y Saba',
    },
    code: 'BQ',
  },
  { name: { en: 'Bosnia and Herzegovina', fr: 'Bosnie-Herzégovine', es: 'Bosnia y Herzegovina' }, code: 'BA' },
  { name: { en: 'Botswana', fr: 'Botswana', es: 'Botsuana' }, code: 'BW' },
  { name: { en: 'Bouvet Island', fr: 'Île Bouvet', es: 'Isla Bouvet' }, code: 'BV' },
  { name: { en: 'Brazil', fr: 'Brésil', es: 'Brasil' }, code: 'BR' },
  {
    name: {
      en: 'British Indian Ocean Territory',
      fr: "Territoire britannique de l'océan Indien",
      es: 'Territorio Británico del Océano Índico',
    },
    code: 'IO',
  },
  { name: { en: 'Brunei', fr: 'Brunei', es: 'Brunéi' }, code: 'BN' },
  { name: { en: 'Bulgaria', fr: 'Bulgarie', es: 'Bulgaria' }, code: 'BG' },
  { name: { en: 'Burkina Faso', fr: 'Burkina Faso', es: 'Burkina Faso' }, code: 'BF' },
  { name: { en: 'Burundi', fr: 'Burundi', es: 'Burundi' }, code: 'BI' },
  { name: { en: 'Cambodia', fr: 'Cambodge', es: 'Camboya' }, code: 'KH' },
  { name: { en: 'Cameroon', fr: 'Cameroun', es: 'Camerún' }, code: 'CM' },
  { name: { en: 'Canada', fr: 'Canada', es: 'Canadá' }, code: 'CA' },
  { name: { en: 'Cape Verde', fr: 'Cap Vert', es: 'Cabo Verde' }, code: 'CV' },
  { name: { en: 'Cayman Islands', fr: 'Îles Caïmans', es: 'Islas Caimán' }, code: 'KY' },
  {
    name: { en: 'Central African Republic', fr: 'République centrafricaine', es: 'República Centroafricana' },
    code: 'CF',
  },
  { name: { en: 'Chad', fr: 'Tchad', es: 'Chad' }, code: 'TD' },
  { name: { en: 'Chile', fr: 'Chili', es: 'Chile' }, code: 'CL' },
  { name: { en: 'China', fr: 'Chine', es: 'China' }, code: 'CN' },
  { name: { en: 'Christmas Island', fr: 'Île Christmas', es: 'Isla de Navidad' }, code: 'CX' },
  { name: { en: 'Cocos (Keeling) Islands', fr: 'Îles Cocos', es: 'Islas Cocos' }, code: 'CC' },
  { name: { en: 'Colombia', fr: 'Colombie', es: 'Colombia' }, code: 'CO' },
  { name: { en: 'Comoros', fr: 'Comores', es: 'Comoras' }, code: 'KM' },
  { name: { en: 'Congo', fr: 'Congo', es: 'Congo' }, code: 'CG' },
  { name: { en: 'Cook Islands', fr: 'Îles Cook', es: 'Islas Cook' }, code: 'CK' },
  { name: { en: 'Costa Rica', fr: 'Costa Rica', es: 'Costa Rica' }, code: 'CR' },
  { name: { en: "Cote D'Ivoire (Ivory Coast)", fr: "Côte d'Ivoire", es: 'Costa de Marfil' }, code: 'CI' },
  { name: { en: 'Croatia', fr: 'Croatie', es: 'Croacia' }, code: 'HR' },
  { name: { en: 'Cuba', fr: 'Cuba', es: 'Cuba' }, code: 'CU' },
  { name: { en: 'Curaçao', fr: 'Curaçao', es: 'Curazao' }, code: 'CW' },
  { name: { en: 'Cyprus', fr: 'Chypre', es: 'Chipre' }, code: 'CY' },
  { name: { en: 'Czech Republic', fr: 'République tchèque', es: 'República Checa' }, code: 'CZ' },
  {
    name: { en: 'Democratic Republic of the Congo', fr: 'Congo (Rép. dém.)', es: 'República Democrática del Congo' },
    code: 'CD',
  },
  { name: { en: 'Denmark', fr: 'Danemark', es: 'Dinamarca' }, code: 'DK' },
  { name: { en: 'Djibouti', fr: 'Djibouti', es: 'Yibuti' }, code: 'DJ' },
  { name: { en: 'Dominica', fr: 'Dominique', es: 'Dominica' }, code: 'DM' },
  { name: { en: 'Dominican Republic', fr: 'République dominicaine', es: 'República Dominicana' }, code: 'DO' },
  { name: { en: 'East Timor', fr: 'Timor oriental', es: 'Timor Oriental' }, code: 'TL' },
  { name: { en: 'Ecuador', fr: 'Équateur', es: 'Ecuador' }, code: 'EC' },
  { name: { en: 'Egypt', fr: 'Égypte', es: 'Egipto' }, code: 'EG' },
  { name: { en: 'El Salvador', fr: 'Salvador', es: 'El Salvador' }, code: 'SV' },
  { name: { en: 'Equatorial Guinea', fr: 'Guinée-Équatoriale', es: 'Guinea Ecuatorial' }, code: 'GQ' },
  { name: { en: 'Eritrea', fr: 'Érythrée', es: 'Eritrea' }, code: 'ER' },
  { name: { en: 'Estonia', fr: 'Estonie', es: 'Estonia' }, code: 'EE' },
  { name: { en: 'Ethiopia', fr: 'Éthiopie', es: 'Etiopía' }, code: 'ET' },
  { name: { en: 'Falkland Islands', fr: 'Îles Malouines', es: 'Islas Malvinas' }, code: 'FK' },
  { name: { en: 'Faroe Islands', fr: 'Îles Féroé', es: 'Islas Feroe' }, code: 'FO' },
  { name: { en: 'Fiji Islands', fr: 'Fidji', es: 'Fiyi' }, code: 'FJ' },
  { name: { en: 'Finland', fr: 'Finlande', es: 'Finlandia' }, code: 'FI' },
  { name: { en: 'France', fr: 'France', es: 'Francia' }, code: 'FR' },
  { name: { en: 'French Guiana', fr: 'Guayane', es: 'Guayana Francesa' }, code: 'GF' },
  { name: { en: 'French Polynesia', fr: 'Polynésie française', es: 'Polinesia Francesa' }, code: 'PF' },
  {
    name: {
      en: 'French Southern Territories',
      fr: 'Terres australes et antarctiques françaises',
      es: 'Tierras Australes y Antárticas Francesas',
    },
    code: 'TF',
  },
  { name: { en: 'Gabon', fr: 'Gabon', es: 'Gabón' }, code: 'GA' },
  { name: { en: 'Gambia The', fr: 'Gambie', es: 'Gambia' }, code: 'GM' },
  { name: { en: 'Georgia', fr: 'Géorgie', es: 'Georgia' }, code: 'GE' },
  { name: { en: 'Germany', fr: 'Allemagne', es: 'Alemania' }, code: 'DE' },
  { name: { en: 'Ghana', fr: 'Ghana', es: 'Ghana' }, code: 'GH' },
  { name: { en: 'Gibraltar', fr: 'Gibraltar', es: 'Gibraltar' }, code: 'GI' },
  { name: { en: 'Greece', fr: 'Grèce', es: 'Grecia' }, code: 'GR' },
  { name: { en: 'Greenland', fr: 'Groenland', es: 'Groenlandia' }, code: 'GL' },
  { name: { en: 'Grenada', fr: 'Grenade', es: 'Granada' }, code: 'GD' },
  { name: { en: 'Guadeloupe', fr: 'Guadeloupe', es: 'Guadalupe' }, code: 'GP' },
  { name: { en: 'Guam', fr: 'Guam', es: 'Guam' }, code: 'GU' },
  { name: { en: 'Guatemala', fr: 'Guatemala', es: 'Guatemala' }, code: 'GT' },
  { name: { en: 'Guernsey and Alderney', fr: 'Guernesey', es: 'Guernsey' }, code: 'GG' },
  { name: { en: 'Guinea', fr: 'Guinée', es: 'Guinea' }, code: 'GN' },
  { name: { en: 'Guinea-Bissau', fr: 'Guinée-Bissau', es: 'Guinea-Bisáu' }, code: 'GW' },
  { name: { en: 'Guyana', fr: 'Guyane', es: 'Guyana' }, code: 'GY' },
  { name: { en: 'Haiti', fr: 'Haïti', es: 'Haití' }, code: 'HT' },
  {
    name: { en: 'Heard Island and McDonald Islands', fr: 'Îles Heard-et-MacDonald', es: 'Islas Heard y McDonald' },
    code: 'HM',
  },
  { name: { en: 'Honduras', fr: 'Honduras', es: 'Honduras' }, code: 'HN' },
  { name: { en: 'Hong Kong S.A.R.', fr: 'Hong Kong', es: 'Hong Kong' }, code: 'HK' },
  { name: { en: 'Hungary', fr: 'Hongrie', es: 'Hungría' }, code: 'HU' },
  { name: { en: 'Iceland', fr: 'Islande', es: 'Islandia' }, code: 'IS' },
  { name: { en: 'India', fr: 'Inde', es: 'India' }, code: 'IN' },
  { name: { en: 'Indonesia', fr: 'Indonésie', es: 'Indonesia' }, code: 'ID' },
  { name: { en: 'Iran', fr: 'Iran', es: 'Irán' }, code: 'IR' },
  { name: { en: 'Iraq', fr: 'Irak', es: 'Irak' }, code: 'IQ' },
  { name: { en: 'Ireland', fr: 'Irlande', es: 'Irlanda' }, code: 'IE' },
  { name: { en: 'Israel', fr: 'Israël', es: 'Israel' }, code: 'IL' },
  { name: { en: 'Italy', fr: 'Italie', es: 'Italia' }, code: 'IT' },
  { name: { en: 'Jamaica', fr: 'Jamaïque', es: 'Jamaica' }, code: 'JM' },
  { name: { en: 'Japan', fr: 'Japon', es: 'Japón' }, code: 'JP' },
  { name: { en: 'Jersey', fr: 'Jersey', es: 'Jersey' }, code: 'JE' },
  { name: { en: 'Jordan', fr: 'Jordanie', es: 'Jordania' }, code: 'JO' },
  { name: { en: 'Kazakhstan', fr: 'Kazakhstan', es: 'Kazajistán' }, code: 'KZ' },
  { name: { en: 'Kenya', fr: 'Kenya', es: 'Kenia' }, code: 'KE' },
  { name: { en: 'Kiribati', fr: 'Kiribati', es: 'Kiribati' }, code: 'KI' },
  { name: { en: 'Kosovo', fr: undefined, es: 'Kosovo' }, code: 'XK' },
  { name: { en: 'Kuwait', fr: 'Koweït', es: 'Kuwait' }, code: 'KW' },
  { name: { en: 'Kyrgyzstan', fr: 'Kirghizistan', es: 'Kirguistán' }, code: 'KG' },
  { name: { en: 'Laos', fr: 'Laos', es: 'Laos' }, code: 'LA' },
  { name: { en: 'Latvia', fr: 'Lettonie', es: 'Letonia' }, code: 'LV' },
  { name: { en: 'Lebanon', fr: 'Liban', es: 'Líbano' }, code: 'LB' },
  { name: { en: 'Lesotho', fr: 'Lesotho', es: 'Lesoto' }, code: 'LS' },
  { name: { en: 'Liberia', fr: 'Liberia', es: 'Liberia' }, code: 'LR' },
  { name: { en: 'Libya', fr: 'Libye', es: 'Libia' }, code: 'LY' },
  { name: { en: 'Liechtenstein', fr: 'Liechtenstein', es: 'Liechtenstein' }, code: 'LI' },
  { name: { en: 'Lithuania', fr: 'Lituanie', es: 'Lituania' }, code: 'LT' },
  { name: { en: 'Luxembourg', fr: 'Luxembourg', es: 'Luxemburgo' }, code: 'LU' },
  { name: { en: 'Macau S.A.R.', fr: 'Macao', es: 'Macao' }, code: 'MO' },
  { name: { en: 'Madagascar', fr: 'Madagascar', es: 'Madagascar' }, code: 'MG' },
  { name: { en: 'Malawi', fr: 'Malawi', es: 'Malaui' }, code: 'MW' },
  { name: { en: 'Malaysia', fr: 'Malaisie', es: 'Malasia' }, code: 'MY' },
  { name: { en: 'Maldives', fr: 'Maldives', es: 'Maldivas' }, code: 'MV' },
  { name: { en: 'Mali', fr: 'Mali', es: 'Malí' }, code: 'ML' },
  { name: { en: 'Malta', fr: 'Malte', es: 'Malta' }, code: 'MT' },
  { name: { en: 'Man (Isle of)', fr: 'Île de Man', es: 'Isla de Man' }, code: 'IM' },
  { name: { en: 'Marshall Islands', fr: 'Îles Marshall', es: 'Islas Marshall' }, code: 'MH' },
  { name: { en: 'Martinique', fr: 'Martinique', es: 'Martinica' }, code: 'MQ' },
  { name: { en: 'Mauritania', fr: 'Mauritanie', es: 'Mauritania' }, code: 'MR' },
  { name: { en: 'Mauritius', fr: 'Île Maurice', es: 'Mauricio' }, code: 'MU' },
  { name: { en: 'Mayotte', fr: 'Mayotte', es: 'Mayotte' }, code: 'YT' },
  { name: { en: 'Mexico', fr: 'Mexique', es: 'México' }, code: 'MX' },
  { name: { en: 'Micronesia', fr: 'Micronésie', es: 'Micronesia' }, code: 'FM' },
  { name: { en: 'Moldova', fr: 'Moldavie', es: 'Moldavia' }, code: 'MD' },
  { name: { en: 'Monaco', fr: 'Monaco', es: 'Mónaco' }, code: 'MC' },
  { name: { en: 'Mongolia', fr: 'Mongolie', es: 'Mongolia' }, code: 'MN' },
  { name: { en: 'Montenegro', fr: 'Monténégro', es: 'Montenegro' }, code: 'ME' },
  { name: { en: 'Montserrat', fr: 'Montserrat', es: 'Montserrat' }, code: 'MS' },
  { name: { en: 'Morocco', fr: 'Maroc', es: 'Marruecos' }, code: 'MA' },
  { name: { en: 'Mozambique', fr: 'Mozambique', es: 'Mozambique' }, code: 'MZ' },
  { name: { en: 'Myanmar', fr: 'Myanmar', es: 'Myanmar' }, code: 'MM' },
  { name: { en: 'Namibia', fr: 'Namibie', es: 'Namibia' }, code: 'NA' },
  { name: { en: 'Nauru', fr: 'Nauru', es: 'Nauru' }, code: 'NR' },
  { name: { en: 'Nepal', fr: 'Népal', es: 'Nepal' }, code: 'NP' },
  { name: { en: 'Netherlands', fr: 'Pays-Bas', es: 'Países Bajos' }, code: 'NL' },
  { name: { en: 'New Caledonia', fr: 'Nouvelle-Calédonie', es: 'Nueva Caledonia' }, code: 'NC' },
  { name: { en: 'New Zealand', fr: 'Nouvelle-Zélande', es: 'Nueva Zelanda' }, code: 'NZ' },
  { name: { en: 'Nicaragua', fr: 'Nicaragua', es: 'Nicaragua' }, code: 'NI' },
  { name: { en: 'Niger', fr: 'Niger', es: 'Níger' }, code: 'NE' },
  { name: { en: 'Nigeria', fr: 'Nigéria', es: 'Nigeria' }, code: 'NG' },
  { name: { en: 'Niue', fr: 'Niue', es: 'Niue' }, code: 'NU' },
  { name: { en: 'Norfolk Island', fr: 'Île de Norfolk', es: 'Isla Norfolk' }, code: 'NF' },
  { name: { en: 'North Korea', fr: 'Corée du Nord', es: 'Corea del Norte' }, code: 'KP' },
  { name: { en: 'North Macedonia', fr: 'Macédoine du Nord', es: 'Macedonia del Norte' }, code: 'MK' },
  {
    name: { en: 'Northern Mariana Islands', fr: 'Îles Mariannes du Nord', es: 'Islas Marianas del Norte' },
    code: 'MP',
  },
  { name: { en: 'Norway', fr: 'Norvège', es: 'Noruega' }, code: 'NO' },
  { name: { en: 'Oman', fr: 'Oman', es: 'Omán' }, code: 'OM' },
  { name: { en: 'Pakistan', fr: 'Pakistan', es: 'Pakistán' }, code: 'PK' },
  { name: { en: 'Palau', fr: 'Palaos', es: 'Palaos' }, code: 'PW' },
  { name: { en: 'Palestinian Territory Occupied', fr: 'Palestine', es: 'Palestina' }, code: 'PS' },
  { name: { en: 'Panama', fr: 'Panama', es: 'Panamá' }, code: 'PA' },
  { name: { en: 'Papua new Guinea', fr: 'Papouasie-Nouvelle-Guinée', es: 'Papúa Nueva Guinea' }, code: 'PG' },
  { name: { en: 'Paraguay', fr: 'Paraguay', es: 'Paraguay' }, code: 'PY' },
  { name: { en: 'Peru', fr: 'Pérou', es: 'Perú' }, code: 'PE' },
  { name: { en: 'Philippines', fr: 'Philippines', es: 'Filipinas' }, code: 'PH' },
  { name: { en: 'Pitcairn Island', fr: 'Îles Pitcairn', es: 'Islas Pitcairn' }, code: 'PN' },
  { name: { en: 'Poland', fr: 'Pologne', es: 'Polonia' }, code: 'PL' },
  { name: { en: 'Portugal', fr: 'Portugal', es: 'Portugal' }, code: 'PT' },
  { name: { en: 'Puerto Rico', fr: 'Porto Rico', es: 'Puerto Rico' }, code: 'PR' },
  { name: { en: 'Qatar', fr: 'Qatar', es: 'Catar' }, code: 'QA' },
  { name: { en: 'Reunion', fr: 'Réunion', es: 'Reunión' }, code: 'RE' },
  { name: { en: 'Romania', fr: 'Roumanie', es: 'Rumanía' }, code: 'RO' },
  { name: { en: 'Russia', fr: 'Russie', es: 'Rusia' }, code: 'RU' },
  { name: { en: 'Rwanda', fr: 'Rwanda', es: 'Ruanda' }, code: 'RW' },
  { name: { en: 'Saint Helena', fr: 'Sainte-Hélène', es: 'Santa Elena' }, code: 'SH' },
  { name: { en: 'Saint Kitts And Nevis', fr: 'Saint-Christophe-et-Niévès', es: 'San Cristóbal y Nieves' }, code: 'KN' },
  { name: { en: 'Saint Lucia', fr: 'Saint-Lucie', es: 'Santa Lucía' }, code: 'LC' },
  { name: { en: 'Saint Pierre and Miquelon', fr: 'Saint-Pierre-et-Miquelon', es: 'San Pedro y Miquelón' }, code: 'PM' },
  {
    name: {
      en: 'Saint Vincent And The Grenadines',
      fr: 'Saint-Vincent-et-les-Grenadines',
      es: 'San Vicente y las Granadinas',
    },
    code: 'VC',
  },
  { name: { en: 'Saint-Barthelemy', fr: 'Saint-Barthélemy', es: 'San Bartolomé' }, code: 'BL' },
  { name: { en: 'Saint-Martin (French part)', fr: 'Saint-Martin', es: 'San Martín' }, code: 'MF' },
  { name: { en: 'Samoa', fr: 'Samoa', es: 'Samoa' }, code: 'WS' },
  { name: { en: 'San Marino', fr: 'Saint-Marin', es: 'San Marino' }, code: 'SM' },
  { name: { en: 'Sao Tome and Principe', fr: 'Sao Tomé-et-Principe', es: 'Santo Tomé y Príncipe' }, code: 'ST' },
  { name: { en: 'Saudi Arabia', fr: 'Arabie Saoudite', es: 'Arabia Saudita' }, code: 'SA' },
  { name: { en: 'Senegal', fr: 'Sénégal', es: 'Senegal' }, code: 'SN' },
  { name: { en: 'Serbia', fr: 'Serbie', es: 'Serbia' }, code: 'RS' },
  { name: { en: 'Seychelles', fr: 'Seychelles', es: 'Seychelles' }, code: 'SC' },
  { name: { en: 'Sierra Leone', fr: 'Sierra Leone', es: 'Sierra Leona' }, code: 'SL' },
  { name: { en: 'Singapore', fr: 'Singapour', es: 'Singapur' }, code: 'SG' },
  {
    name: {
      en: 'Sint Maarten (Dutch part)',
      fr: 'Saint Martin (partie néerlandaise)',
      es: 'San Martín (parte neerlandesa)',
    },
    code: 'SX',
  },
  { name: { en: 'Slovakia', fr: 'Slovaquie', es: 'Eslovaquia' }, code: 'SK' },
  { name: { en: 'Slovenia', fr: 'Slovénie', es: 'Eslovenia' }, code: 'SI' },
  { name: { en: 'Solomon Islands', fr: 'Îles Salomon', es: 'Islas Salomón' }, code: 'SB' },
  { name: { en: 'Somalia', fr: 'Somalie', es: 'Somalia' }, code: 'SO' },
  { name: { en: 'South Africa', fr: 'Afrique du Sud', es: 'Sudáfrica' }, code: 'ZA' },
  {
    name: {
      en: 'South Georgia',
      fr: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
      es: 'Georgia del Sur y las Islas Sandwich del Sur',
    },
    code: 'GS',
  },
  { name: { en: 'South Korea', fr: 'Corée du Sud', es: 'Corea del Sur' }, code: 'KR' },
  { name: { en: 'South Sudan', fr: 'Soudan du Sud', es: 'Sudán del Sur' }, code: 'SS' },
  { name: { en: 'Spain', fr: 'Espagne', es: 'España' }, code: 'ES' },
  { name: { en: 'Sri Lanka', fr: 'Sri Lanka', es: 'Sri Lanka' }, code: 'LK' },
  { name: { en: 'Sudan', fr: 'Soudan', es: 'Sudán' }, code: 'SD' },
  { name: { en: 'Suriname', fr: 'Surinam', es: 'Surinam' }, code: 'SR' },
  {
    name: { en: 'Svalbard And Jan Mayen Islands', fr: 'Svalbard et Jan Mayen', es: 'Svalbard y Jan Mayen' },
    code: 'SJ',
  },
  { name: { en: 'Swaziland', fr: 'Swaziland', es: 'Suazilandia' }, code: 'SZ' },
  { name: { en: 'Sweden', fr: 'Suède', es: 'Suecia' }, code: 'SE' },
  { name: { en: 'Switzerland', fr: 'Suisse', es: 'Suiza' }, code: 'CH' },
  { name: { en: 'Syria', fr: 'Syrie', es: 'Siria' }, code: 'SY' },
  { name: { en: 'Taiwan', fr: 'Taïwan', es: 'Taiwán' }, code: 'TW' },
  { name: { en: 'Tajikistan', fr: 'Tadjikistan', es: 'Tayikistán' }, code: 'TJ' },
  { name: { en: 'Tanzania', fr: 'Tanzanie', es: 'Tanzania' }, code: 'TZ' },
  { name: { en: 'Thailand', fr: 'Thaïlande', es: 'Tailandia' }, code: 'TH' },
  { name: { en: 'The Bahamas', fr: 'Bahamas', es: 'Bahamas' }, code: 'BS' },
  { name: { en: 'Togo', fr: 'Togo', es: 'Togo' }, code: 'TG' },
  { name: { en: 'Tokelau', fr: 'Tokelau', es: 'Tokelau' }, code: 'TK' },
  { name: { en: 'Tonga', fr: 'Tonga', es: 'Tonga' }, code: 'TO' },
  { name: { en: 'Trinidad And Tobago', fr: 'Trinité et Tobago', es: 'Trinidad y Tobago' }, code: 'TT' },
  { name: { en: 'Tunisia', fr: 'Tunisie', es: 'Túnez' }, code: 'TN' },
  { name: { en: 'Turkey', fr: 'Turquie', es: 'Turquía' }, code: 'TR' },
  { name: { en: 'Turkmenistan', fr: 'Turkménistan', es: 'Turkmenistán' }, code: 'TM' },
  { name: { en: 'Turks And Caicos Islands', fr: 'Îles Turques-et-Caïques', es: 'Islas Turcas y Caicos' }, code: 'TC' },
  { name: { en: 'Tuvalu', fr: 'Tuvalu', es: 'Tuvalu' }, code: 'TV' },
  { name: { en: 'Uganda', fr: 'Uganda', es: 'Uganda' }, code: 'UG' },
  { name: { en: 'Ukraine', fr: 'Ukraine', es: 'Ucrania' }, code: 'UA' },
  { name: { en: 'United Arab Emirates', fr: 'Émirats arabes unis', es: 'Emiratos Árabes Unidos' }, code: 'AE' },
  { name: { en: 'United Kingdom', fr: 'Royaume-Uni', es: 'Reino Unido' }, code: 'GB' },
  { name: { en: 'United States', fr: 'États-Unis', es: 'Estados Unidos' }, code: 'US' },
  {
    name: {
      en: 'United States Minor Outlying Islands',
      fr: 'Îles mineures éloignées des États-Unis',
      es: 'Islas Menores Exteriores de los Estados Unidos',
    },
    code: 'UM',
  },
  { name: { en: 'Uruguay', fr: 'Uruguay', es: 'Uruguay' }, code: 'UY' },
  { name: { en: 'Uzbekistan', fr: 'Ouzbékistan', es: 'Uzbekistán' }, code: 'UZ' },
  { name: { en: 'Vanuatu', fr: 'Vanuatu', es: 'Vanuatu' }, code: 'VU' },
  { name: { en: 'Vatican City State (Holy See)', fr: 'voir Saint', es: 'Ciudad del Vaticano' }, code: 'VA' },
  { name: { en: 'Venezuela', fr: 'Venezuela', es: 'Venezuela' }, code: 'VE' },
  { name: { en: 'Vietnam', fr: 'Viêt Nam', es: 'Vietnam' }, code: 'VN' },
  {
    name: { en: 'Virgin Islands (British)', fr: 'Îles Vierges britanniques', es: 'Islas Vírgenes Británicas' },
    code: 'VG',
  },
  {
    name: { en: 'Virgin Islands (US)', fr: 'Îles Vierges des États-Unis', es: 'Islas Vírgenes de los Estados Unidos' },
    code: 'VI',
  },
  { name: { en: 'Wallis And Futuna Islands', fr: 'Wallis-et-Futuna', es: 'Wallis y Futuna' }, code: 'WF' },
  { name: { en: 'Western Sahara', fr: 'Sahara Occidental', es: 'Sahara Occidental' }, code: 'EH' },
  { name: { en: 'Yemen', fr: 'Yémen', es: 'Yemen' }, code: 'YE' },
  { name: { en: 'Zambia', fr: 'Zambie', es: 'Zambia' }, code: 'ZM' },
  { name: { en: 'Zimbabwe', fr: 'Zimbabwe', es: 'Zimbabue' }, code: 'ZW' },
];

const getCountriesByLanguage = (language: Language) => {
  return countries
    .map((country) => {
      return {
        name: country.name[language] ?? country.name.en,
        code: country.code,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
};

export { getCountriesByLanguage };
